export var ComponentState = /*#__PURE__*/function (ComponentState) {
  ComponentState["Active"] = "active";
  ComponentState["Checked"] = "checked";
  ComponentState["Default"] = "default";
  ComponentState["Disabled"] = "disabled";
  ComponentState["Focus"] = "focus";
  ComponentState["Hover"] = "hover";
  ComponentState["Invalid"] = "invalid";
  ComponentState["Loaded"] = "loaded";
  ComponentState["Loading"] = "loading";
  ComponentState["Selected"] = "selected";
  ComponentState["Valid"] = "valid";
  ComponentState["Unselected"] = "Unselected";
  return ComponentState;
}({});
export var getTextInputStyles = function getTextInputStyles(theme, _ref, componentName) {
  var {
    isDisabled = false,
    isInvalid = false,
    isFocused = false,
    isHovered = false
  } = _ref;
  if (componentName === void 0) {
    componentName = 'TextInput';
  }
  var {
    [ComponentState.Disabled]: {
      backgroundColor: disabledBackgroundColor
    },
    [ComponentState.Invalid]: {
      borderColor: invalidBorderColor
    },
    [ComponentState.Focus]: {
      borderColor: focusBorderColor
    },
    [ComponentState.Hover]: {
      borderColor: hoverBorderColor
    },
    backgroundColor: baseStyleBackgroundColor,
    borderColor: baseStyleBorderColor,
    color,
    fontSize,
    fontWeight,
    placeholderColor,
    smallScreen
  } = theme.components[componentName].baseStyle;
  var backgroundColor = isDisabled ? disabledBackgroundColor : baseStyleBackgroundColor;
  var borderColor = isDisabled ? baseStyleBorderColor : isInvalid ? invalidBorderColor : isFocused ? focusBorderColor : isHovered ? hoverBorderColor : baseStyleBorderColor;
  var responsiveFontSizeStyles = "\n        font-size: " + fontSize + ";\n\n        " + theme.responsive.smallScreenOnly("\n            font-size: " + smallScreen.fontSize + ";\n        ") + "\n    ";
  return {
    backgroundColor,
    borderColor,
    color,
    fontSize,
    fontStyles: "\n            color: " + color + ";\n            font-weight: " + fontWeight + ";\n            font-weight: " + fontWeight + ";\n            " + responsiveFontSizeStyles + ";\n\n            &::placeholder {\n                color: " + placeholderColor + ";\n            }\n        ",
    fontWeight,
    placeholderColor,
    smallScreen
  };
};